<div #prfpctr class="avatar">
  @if (imagen) {
    <img src="{{imagen}}" alt="">
  } @else {
    <p>{{ (colorTexto?.[0] || '').toUpperCase() }}</p>
  }

</div>